export class ArrayHelper {


  static makeBatches<T>(array: T[], maxCount: number): T[][] {
    const result: T[][] = [];
    if (array.length > maxCount) {
      const batch = array.splice(0, maxCount);
      result.push(batch);
    } else result.push(array);
    return result;
  }

  static getStrings<T>(array: T[], propertyName: string): string[] {
    let result: string[] = [];
    for (const item of array) {
      const val: string = (item as Record<string, unknown>)[propertyName] as string;
      if (result.indexOf(val) === -1) result.push(val);
    }
    result = result.sort((a, b) => {
      return (a?.toUpperCase() || "").localeCompare(b?.toUpperCase() || "")
    });

    return result;
  }

  static getIds<T>(array: T[], propertyName: string): number[] {
    const result: number[] = [];
    for (const item of array) {
      const id = parseInt((item as Record<string, unknown>)[propertyName] as string, 0);
      if (id > 0 && result.indexOf(id) === -1) result.push(id);
    }

    return result;
  }

  static getOne<T>(array: T[], propertyName: string, value: unknown): T | null {
    for (const item of array) if ((item as Record<string, unknown>)[propertyName] === value) return item;
    return null
  }

  static getOneMultiCondition<T>(array: T[], propertyNames: string[], values: unknown[]): T | null {
    for (const item of array) {
      let match = true;
      for (let i = 0; i < propertyNames.length; i++) {
        if ((item as Record<string, unknown>)[propertyNames[i]] !== values[i]) match = false;
      }
      if (match) return item;
    }
    return null
  }

  static limit<T>(array: T[], count: number): T[] {
    const result: T[] = []
    for (let i = 0; i < array.length && i < count; i++) result.push(array[i]);
    return result;
  }

  static getAll<T>(array: T[], propertyName: string, value: unknown): T[] {
    const result: T[] = []
    for (const item of array) if ((item as Record<string, unknown>)[propertyName] === value) result.push(item);
    return result;
  }

  static getAllContaining<T>(array: T[], propertyName: string, value: string): T[] {
    const result: T[] = []
    for (const item of array) {
      const propertyValue = (item as Record<string, unknown>)[propertyName];
      if (propertyValue && propertyValue.toString().toLowerCase().indexOf(value.toLowerCase()) > -1) result.push(item);
    }
    return result;
  }

  static getAllArray<T>(array: T[], propertyName: string, values: unknown[]): T[] {
    const result: T[] = []
    for (const item of array) if (values.indexOf((item as Record<string, unknown>)[propertyName]) > -1) result.push(item);
    return result;
  }

  static fillArray(contents: string, length: number): string[] {
    const result: string[] = [];
    for (let i = 0; i < length; i++) result.push(contents);
    return result;
  }

  static sort<T>(array: T[], propertyName: string, desc: boolean): void {
    array.sort((a, b) => {
      const aValue = (a as Record<string, unknown>)[propertyName];
      const bValue = (b as Record<string, unknown>)[propertyName];
      if (desc) return (aValue > bValue) ? -1 : 1;
      else return (aValue < bValue) ? -1 : 1;
    });
  }

}
